import { Divider } from "@digdir/designsystemet-react";
import type { ReactNode } from "react";

export const BekreftelseDetaljerContainer = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  return (
    <div>
      <Divider />
      <div className="flex flex-col gap-8 rounded-3xl">{children}</div>
      <Divider />
    </div>
  );
};
